const ADMIN_ALLOWLIST: Set<string> = new Set<string>([
  'eyal.udassin@gmail.com',
  'daniel.udassin@gmail.com',
  'elad@markerfilms.com',
]);

export function normalizeEmail(email: string | null | undefined): string {
  return (email || '').trim().toLowerCase();
}

export function isAdminUserEmail(email: string | null | undefined): boolean {
  return ADMIN_ALLOWLIST.has(normalizeEmail(email));
}

